<template>
  <section :class="['winners', userDetails.msisdn === '' ? '' : 'wloggedin']">
    <div class="winners__header">
      <div class="winners__header__content">
        <h1>{{ getTranslations.visitor_visitor_header_winners }}</h1>
      </div>
    </div>
    <div class="winners__heading">
      <h2>{{ getTranslations.components_winners_winner_history }}</h2>
    </div>
    <div class="winners__table">
      <span v-if="getNumberOfWinners === 0" :class="['no_winners_state', (getNumberOfWinners === 0) ? '' : ' winners_full']">{{ getTranslations.visitor_winners_no_winners }}</span>
      <ul :class="[getNumberOfWinners === 0 ? 'winners_empty' : '']">
        <li v-for="(winner, index) in getAllWinners" :key="index">
          <div class="winners__table__date">
            {{ normalizeDate(winner.localDateTime) }}
          </div>
          <div class="winners__table__user">
            <div class="avatar-cont">
              <img :src="winner.userDTO.avatar" class="avatar" alt="">
            </div>
            <span v-if="winnersShowMsisdn">{{ winner.userDTO.msisdn }}</span>
            <span v-else>{{ winner.userDTO.firstName }} {{ winner.userDTO.lastName }}</span>
          </div>
          <div class="winners__table__prize">
            <h3 v-if="winner.prizeDTO.type === 'MONTHLY'">{{ getTranslations.components_winners_monthly_prize }}</h3>
            <h3 v-else-if="winner.prizeDTO.type === 'WEEKLY'">{{ getTranslations.components_winners_weekly_prize }}</h3>
            <h3 v-else-if="winner.prizeDTO.type === 'DAILY'">{{ getTranslations.components_winners_daily_prize }}</h3>
            <h3 v-else-if="winner.prizeDTO.type === 'GRAND'">{{ getTranslations.components_winners_grand_prize }}</h3>
            <span>{{ winner.prizeDTO.headline }}</span>
          </div>
        </li>
      </ul>
      <input v-show="moreWinnersButton && !showRestWinners" type="submit" value="···"
             :class="['load-more btn2 btn2--std btn2--small btn2--green', (getNumberOfWinners === 0) ? ' winners_empty' : '']" @click.prevent="displayMore">
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions, mapMutations, mapState } from 'vuex';
import Vue from 'vue';

const moment = require('moment');

Vue.use(require('vue-moment'), {
  moment,
});

export default {
  name: 'winners',
  data() {
    return {
      showRestWinners: false,
    };
  },
  beforeRouteLeave(to, from, next) {
    /* eslint-disable */
    console.log('==> inside component\'s beforeRouteLeave: Winners');
    console.log(`from.path: ${from.path}`);
    console.log(`to.path: ${to.path}`);
    this.storeVisitorWinners(this.getLocale);
    next();
    /* eslint-enable */
  },
  methods: {
    ...mapActions('profile', [
      'storeVisitorWinners',
    ]),
    ...mapMutations('profile', [
      'setMoreWinnersButton',
    ]),
    displayMore() {
      this.showRestWinners = true;
      this.setMoreWinnersButton(false);
    },
    normalizeDate(date) {
      moment.locale(localStorage.getItem('locale'));
      return moment(date).format('DD/MM/YYYY');
    },
  },
  computed: {
    ...mapState('profile', [
      'visitorWinners',
      'moreWinnersButton',
      'extraArraysWinners',
    ]),
    ...mapState('common', [
      'userDetails',
      'winnersShowMsisdn',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
      'getLocale',
    ]),
    getNumberOfWinners() {
      return this.getAllWinners.length;
    },
    getAllWinners() {
      if (this.showRestWinners) {
        return this.visitorWinners;
      }
      return this.extraArraysWinners;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Winners.vue